import { Get, getAPIUrl, Post } from "../../../ApiServices/apiMethod";
import { HomePageService } from "../../../ApiServices/Axios/Index";

export const AddMatchEndpoint = {
  getSports: `/admin/content/getSports`,
  getLeagues: `/admin/content/getLeagues?sport=`,
  getMatches: `/admin/content/getMatches?sport=`,
  addMatch: `/admin/content/addMatchContent`,
  uploadImage: `/admin/content/uploadImage`,
};

export const getSports = (param = "") => {
  const url = getAPIUrl(AddMatchEndpoint.getSports, param);
  return Get(HomePageService, url, true);
};
export const getLeagues = (param = "") => {
  const url = getAPIUrl(AddMatchEndpoint.getLeagues, param);
  return Get(HomePageService, url, true);
};
export const getMatches = (param = "") => {
  const url = getAPIUrl(AddMatchEndpoint.getMatches, param);
  return Get(HomePageService, url, true);
};
export const addMatch = (data, param = "") => {
  const url = getAPIUrl(AddMatchEndpoint.addMatch, param);
  return Post(HomePageService, url, data, true);
};
export const uploadImage = (data) => {
  const formData = new FormData();
  Object.keys(data).forEach((k) => {
    if (data[k]) {
      formData.append(k, data[k]);
    }
  });
  const url = getAPIUrl(AddMatchEndpoint.uploadImage);
  return Post(HomePageService, url, formData, true, true);
};
